import { render, staticRenderFns } from "./MasterWalletDetails.vue?vue&type=template&id=84125eb4&scoped=true"
import script from "./MasterWalletDetails.vue?vue&type=script&lang=js"
export * from "./MasterWalletDetails.vue?vue&type=script&lang=js"
import style0 from "./MasterWalletDetails.vue?vue&type=style&index=0&id=84125eb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84125eb4",
  null
  
)

export default component.exports